import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { FileText } from 'lucide-react';

const NachlassaufloesungDortmund = () => {
  return (
    <ServiceTemplate
      title="Nachlassauflösung in Dortmund"
      slug="nachlassaufloesung-dortmund"
      icon={FileText}
      intro="Respektvolle Auflösung von Nachlässen in Dortmund. Nach einem Todesfall übernehmen wir die sorgfältige Räumung der Wohnung oder des Hauses. Mit Dokumentensicherung, Wertermittlung und transparenter Anrechnung. Diskret, zuverlässig und besenrein."
      whatIncluded="Wir sichten gemeinsam mit Ihnen oder nach Anweisung alle Räume, sichern wichtige Dokumente (Testamente, Versicherungen, Urkunden), ermitteln Werte von Möbeln und Gegenständen, sortieren systematisch und entsorgen besenrein."
      whenNeeded="Nach Todesfall, bei Erbauseinandersetzungen, wenn Sie nicht vor Ort wohnen oder wenn die emotionale Belastung zu groß ist. Auch bei geerbten Immobilien, die schnell geräumt werden müssen."
      pricing="Je nach Objektgröße und Wert der Gegenstände: Wohnung 1.000–2.500 €, Einfamilienhaus 2.000–4.500 €. Wertanrechnung reduziert den Preis oft erheblich. Nach Sichtung erhalten Sie einen verbindlichen Festpreis. Dauer: 1–2 Tage."
      valueCredit="Nachlässe enthalten häufig wertvolle Möbel, Schmuck, Antiquitäten oder Sammlungen. Wir schätzen alles sorgfältig und rechnen transparent an. Sie erhalten eine detaillierte Aufstellung."
      disposal="Respektvolle und gesetzeskonforme Entsorgung. Dokumente werden sicher behandelt, verwertbare Gegenstände getrennt, Rest fachgerecht entsorgt. Auf Wunsch Dokumentation und Entsorgungsnachweise."
    />
  );
};

export default NachlassaufloesungDortmund;